import { Injectable } from '@angular/core';
import { getProjectModel, newProjectModel, ProjectListModel,ProjectWorldModel, ProjectWorldListModel, ProjectCampListModel} from '../models/project.model';
import { getCampaignsModel, newCampaignModel, CampaignModel, DashboardCampaigns } from '../models/campaign.model';
import { MainService } from './main.service';
import { map } from 'rxjs';
import { UsersService } from './users.service';
import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  constructor(
    private main: MainService,
    private usrService : UsersService
  ) { }
  areaName : string = '/projects'

  getProjects(id_company : number){
    var get : getProjectModel =  new getProjectModel()
    get.active = 1;
    return this.main.getRequest(this.areaName + "/show/" + id_company).pipe(
      map((x:any)=>{
              let objReturn = new ProjectListModel();
              if(x.message == 'Success'){
                  x.data.forEach((e:any) => {
                      let tmpdate = new Date(e.date);
                      tmpdate.setTime(tmpdate.getTime() + 6 * 60 * 60 * 1000);
                      let tmpYear = tmpdate.getFullYear();
                      if(tmpYear != tmpdate.getFullYear()){
                          if(!objReturn.pastyears[tmpYear]){
                              objReturn.pastyears[tmpYear] =  new Array<any>()
                          }
                          objReturn.pastyears[tmpYear].push(e);
                      }else{
                         if(e.status == 1) {
                             objReturn.progress.push(e)
                         } 
                         else {
                             objReturn.finished.push(e)
                         }  
                      }
                  });
              }
              return objReturn;
      }));
  }

  getProject(id_proj : number){
    return this.main.getRequest(this.areaName + "/" + id_proj);
  }

  newProject(newProject : newProjectModel){
    return this.main.postRequest(newProject, this.areaName + "/create");
  }

  editProject(newCampain : newProjectModel){
    return this.main.postRequest(newCampain, this.areaName + "/edit");
  }

  deleteProject(campid : number){
    return this.main.deleteRequest(this.areaName + "/delete/" + campid);
  }

  getProjectWorlds(id_proj : number){
    return this.main.getRequest(this.areaName + "/world/" + id_proj);
  }

  newProjectWorld(newWorld : ProjectWorldModel){
    return this.main.postRequest(newWorld, this.areaName + "/world/create");
  }

  editProjectWorld(sameWorld : ProjectWorldModel){
    return this.main.postRequest(sameWorld, this.areaName + "/world/edit");
  }

  deleteProjectWorld(wid : number){
    return this.main.deleteRequest(this.areaName + "/world/delete/" + wid);
  }

  newCampaign(newCampaign : newCampaignModel){
    return this.main.postRequest(newCampaign, this.areaName + "/campaign/create");
  }

  getCampaigns(id_proj: number){
    return this.main.getRequest(this.areaName + "/campaign/show/" + id_proj);
  }

  editCampaign(newCampain : newCampaignModel){
    return this.main.postRequest(newCampain, this.areaName + "/campaign/edit");
  }

  deleteCampaign(camp_id : number){
    return this.main.deleteRequest(this.areaName + "/campaign/delete/" + camp_id);
  }

  getPromotionFiles(id_proj : number){
    return this.main.getRequest(this.areaName + "/files/promotions/" + id_proj);
  }

  uploadPromotionFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/promotions/");
  }

  getProjectsChangelog(id_project : number){
    return this.main.getRequest(this.areaName + "/changelog/" + id_project);
  }

  newProjectsMessage(newMessage : any){
    return this.main.postRequest(newMessage, this.areaName + "/message/");
  }

  getProjectsCampaignsChangelog(id_project : number){
    return this.main.getRequest(this.areaName + "/campaign/changelog/" + id_project);
  }

  newProjectsCampaignsMessage(newMessage : any){
    return this.main.postRequest(newMessage, this.areaName + "/campaign/message/");
  }

  //campaing phased related code
  setPhase(phase_id : number, camp_rol : number, status : number, id_campana_proyecto : number, commentary : string){
    return this.main.postRequest({ phase_id : phase_id, camp_rol : camp_rol, status :  status, id_campana_proyecto : id_campana_proyecto , commentary :  commentary}, this.areaName + "/campaign/setphase/");
  }

  getCampaign(id_campaign : number){
    return this.main.getRequest(this.areaName + "/campaigns/show/" + id_campaign);
  }

  uploadCampaignProjectFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/campaign/");
  }

  getProjectsCampaignsFileChangelog(id_camp_proy_archivo : number){
    return this.main.getRequest(this.areaName + "/campaign/file/changelog/" + id_camp_proy_archivo);
  }

  newProjectsCampaignsFileMessage(newMessage : any){
    return this.main.postRequest(newMessage, this.areaName + "/campaign/file/message/");
  }

  getProviders(){
    return this.main.getRequest(this.areaName + "/providers/show/");
  }

  setProvidersSurvLock(item : any){
    return this.main.postRequest(item, this.areaName + "/providers/lock/");
  }

  getProvidersList(){
    return this.main.getRequest(this.areaName + "/providers/list/");
  }

  activeProvider(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/active");
  }

  getProviderAdminView(provi: any){
    return this.main.getRequest(this.areaName + "/providers/admin/" + provi);
  }

  setProvider(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/create");
  }

  editProvider(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/edit");
  }

  setProviderMemberCanEdit(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/members/setedit");
  }

  setProviderMemberNotify(provi : any){
    return this.main.postRequest(provi, this.areaName + "/providers/members/setnotify");
  }

  deleteProvider(provi : any){
    return this.main.getRequest(this.areaName + "/providers/delete/" + provi);
  }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean{
    return this.usrService.getUser().id_rol == environment.role_admin_id || (buho==null&&this.isBuhoUsr()) || (client==null&&this.isClientUsr()) || (((buho?this.isBuhoUsr():false) || (client?this.isClientUsr():false)) && (this.usrService.getUser().permissions.includes(key)));
  }

  uploadCampaignProviderFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/provider/");
  }

  getProvidersSurveys(id_camp : number ){
    return this.main.getRequest(this.areaName + "/providersurveys/" + id_camp);
  }

  deleteProviderSurvey(id : number){
    return this.main.deleteRequest( this.areaName + "/providersurveys/delete/" + id);
  }
  
  saveMember(member: any) {    
    return this.main.postRequest(member, this.areaName +  "/providers/members/create");
  }

  saveResponse(response: any) {    
    return this.main.postRequest(response, this.areaName +  "/providersurveys/response/save");
  }

  getProviderView(view: any) {    
    return this.main.getRequest(this.areaName + "/providersurveys/view/" + view);
  }

  uploadProviderResponseFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/provider_survey_response");
  }

  reuploadCampaignProviderFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/providerreload/");
  }

  resendProviverSurveyEmail(item : any){
    return this.main.postRequest(item, this.areaName +  "/providers/resend/");
  }

  getProviderMemberSignUpView(view: any) {    
    return this.main.getRequest(this.areaName + "/providersignup/view/" + view);
  }

  setProviderMemberPassword(newpass : any){
    return this.main.postRequest(newpass, this.areaName + "/providermember/setpassword/");
  }

  setProviderMemberActive(active : any){
    return this.main.postRequest(active, this.areaName + "/providers/members/active");
  }

  deleteProviderMember(id_provider_member : number){
    return this.main.deleteRequest(this.areaName + "/members/delete/" + id_provider_member);
  }

  getListProjectsProvidersView() {    
    return this.main.getRequest(this.areaName + "/projects/member/show/");
  }

  getFormUrl(id_provider_survey : number){
    return this.main.postRequest({ id_provider_survey : id_provider_survey }, this.areaName + "/getformurl/");
  }

  isBuhoUsr(): boolean{
    return  this.usrService.getUser().id_rol == environment.role_buho ||  this.usrService.getUser().id_rol == environment.role_admin_id;
  }

  getProviverSurveyChangelog(prov_surv : number){
    return this.main.getRequest(this.areaName + "/providersurv/changelog/" + prov_surv);
  }

  getProviverSurveyPreview(prov_surv : number){
    return this.main.getRequest(this.areaName + "/providersurveys/preview/" + prov_surv);
  }

  getProviverMemberInfo(prov_member_id : number){
    return this.main.getRequest(this.areaName + "/providers/members/view/" + prov_member_id);
  }

  editMember(member: any) {    
    return this.main.postRequest(member, this.areaName +  "/providers/members/edit");
  } 

  newProviverSurveyMessage(newMessage : any){
      return this.main.postRequest(newMessage, this.areaName +  "/providersurv/message/");
  }

  //preproyectos
  newPreprojectForm(newPreproject : any){
    return this.main.postRequest(newPreproject, this.areaName +  "/preprojectform/create");
  }

  updatePreprojectForm(newPreproject : any){
    return this.main.postRequest(newPreproject, this.areaName +  "/preprojectform/edit");
  }

  getPreprojectCamp(id : number){
    return this.main.getRequest(this.areaName + "/preprojectform/" + id);
  }

  getPreprojectTotals(id : number){
    return this.main.getRequest(this.areaName + "/preprojecttotals/" + id);
  }
  
  uploadPreprojectTotalFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/preprojectotals/");
  }

  uploadPreprojectFormFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/preprojectform/");
  }

  uploadPreprojectPDFFile(form : FormData){
    return this.main.postRequestFormData(form, this.areaName + "/files/preprojectpdf/");
  }

  getPreprojectPdfs(id : number){
    return this.main.getRequest(this.areaName + "/preprojectpdfs/" + id);
  }

  deletePreprojectForm(id : number){
    return this.main.deleteRequest(this.areaName + "/preprojectform/delete/" + id);
  }

  deletePreprojectPDF(id : number){
    return this.main.deleteRequest(this.areaName + "/preprojectpdfs/delete/" + id);
  }

  generatePreproject1(preproject : any){
    return this.main.postDataUrlExt(preproject, "http://134.209.122.193:8001/preproyecto_auto_nest/" );
  }

  generatePreproject(preproject : any){
    return this.main.postRequest(preproject, this.areaName + "/preprojectform/generate" );
  }

  isClientUsr(): boolean{
    return  this.usrService.getUser().id_rol == environment.role_client;
  }

  getTokenData(token : any){
    return jwt_decode(token);
  }

  
}

export class PreProyecto {
  id! : number;
  id_camp! : number;
  nombre_str!: string;
  cliente!: string;
  nombre!: string;
  folio!: string;
  proyecto!: string;
  contacto!: string;
  tipo!: string;
  area_responsable!: string;
  impresion!: string;
  color!: string;
  tipo_envio!: string;
  recepcion!: string;
  dia_inicio!: number;
  mes_inicio!: string;
  ano_inicio!: number;
  dia_fin!: number;
  mes_fin!: string;
  ano_fin!: number;
  excel_formulario!: string;
  excel_totales!: string;
  pdfs!: string[];
  created_at! : string;
}